import { AutoThrow } from "@pdfking/errors"
import type { Distance } from "@pdfking/math"
import type { Math as MathExpr, Quantity } from "@pdfking/quantity"
import { EvaluateMath, Operation } from "@pdfking/quantity"

import type { GrowSize } from "../../../types/Dimension"

// symbols are lengths (exp 1); a `Distance` is a branded base-unit number, so
// the whole evaluation runs on plain magnitudes.
const q = (v: number): Quantity => ({
  enum: Operation.NUM,
  vars: [v],
  exp: 1,
})

const ctx_to_record = (size: GrowSize): Record<string, Quantity> => ({
  width: q(size.width),
  height: q(size.height),
  depth: q(size.depth),
  sheet_depth: q(size.sheet_depth),
})

/** A grow's dimension at `size`. */
export const ExpandDimension = (d: MathExpr, size: GrowSize): Distance => {
  const {
    vars: [first],
  } = AutoThrow(
    EvaluateMath(d, {
      min: 1,
      max: 1,
      context: ctx_to_record(size),
    })
  )
  // exp pinned to 1 (a length): re-brand the magnitude as a Distance.
  return first as Distance
}
